import { useQuery } from '@apollo/client'
import { showApiErrorToast } from '@npco/zeller-design-system'

import { GetCustomers } from 'graphql/merchant-portal/queries/customers'
import { GetCustomers as GetCustomersResponse } from 'types/gql-types/GetCustomers'

export const useFetchUsers = () => {
  const { loading, data } = useQuery<GetCustomersResponse>(GetCustomers, {
    onError: (error) => {
      showApiErrorToast(error)
    },
    // Ignore errors for now to fix users page in dev environment.
    // we will need to remove the site field from GetCustomers when BE is ready.
    errorPolicy: 'ignore',
  })

  return {
    loading,
    customers: data?.getCustomers,
  }
}
